var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils, PCSS } from './_default-imports';
import { TweenService } from '../../animations/tween-service';
import { Easings } from '../../animations/easings';
import { LogLevel } from '../../logger';
import { CustomElementUtils } from '../../utils-customelement';
//namespace Pacem.Components {
export var DockMode;
(function (DockMode) {
    DockMode["Top"] = "top";
    DockMode["Bottom"] = "bottom";
})(DockMode || (DockMode = {}));
/** @deprecated */
let PacemDockElement = class PacemDockElement extends PacemEventTarget {
    constructor(_tweener = new TweenService()) {
        super();
        this._tweener = _tweener;
        this.mode = DockMode.Top;
        this.transitionDuration = 300 /* msecs */;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'dock' && (!Utils.isNull(old) || val != false))
            this._doDock();
        else if (name === 'mode' && this.dock === true)
            this._doDock();
    }
    _animate(from, to) {
        var transition = this.transitionDuration;
        if (!(transition > 0))
            transition = 300;
        //
        return this._tweener.run(from, to, transition, this.delay, Easings.sineInOut, (time, value) => {
            this._setOffset(value);
        }).then(() => {
            this._resetOffset();
        });
    }
    _setOffset(value) {
        this.style.transform = 'translateY(' + value + 'px)';
    }
    _resetOffset() {
        this.style.transform = '';
    }
    _compute() {
        const offset = Utils.offset(this);
        const css = getComputedStyle(this);
        const scrollTop = Utils.scrollTop;
        switch (this.mode) {
            case DockMode.Bottom:
                const marginBottom = parseInt(css.marginBottom);
                const bottom = offset.top;
                const deltaBottom = Utils.windowSize.height - (bottom - scrollTop + this.offsetHeight);
                return { delta: deltaBottom + marginBottom };
            case DockMode.Top:
                const marginTop = parseInt(css.marginTop);
                const top = offset.top;
                const delta = top - scrollTop;
                return { delta: -(delta + marginTop) };
        }
    }
    _doDock() {
        const docked = this.dock;
        if (docked) {
            const cmp = this._compute();
            if (Utils.isNull(cmp))
                return;
            //
            // adding the css classes first...
            Utils.addClass(this, PCSS + '-dock');
            switch (this.mode) {
                case DockMode.Bottom:
                    Utils.removeClass(this, PCSS + '-dock-top');
                    Utils.addClass(this, PCSS + '-dock-bottom');
                    break;
                case DockMode.Top:
                    Utils.removeClass(this, PCSS + '-dock-bottom');
                    Utils.addClass(this, PCSS + '-dock-top');
                    break;
            }
            // ...so have to flip `from` and `to` 
            const from = -cmp.delta;
            const to = 0;
            const state = CustomElementUtils.getAttachedPropertyValue(this, 'pacem-dock:state') || 0;
            CustomElementUtils.setAttachedPropertyValue(this, 'pacem-dock:state', -from + state);
            this.log(LogLevel.Info, `animating from ${from}px to ${to}px`);
            //
            this._animate(from, to) /*.then(() => { })*/;
        }
        else {
            // removing the css classes first then animating
            const from = CustomElementUtils.getAttachedPropertyValue(this, 'pacem-dock:state');
            CustomElementUtils.deleteAttachedPropertyValue(this, 'pacem-dock:state');
            const to = 0;
            this.log(LogLevel.Info, `animating back from ${from}px to ${to}px`);
            Utils.removeClass(this, `${PCSS}-dock ${PCSS}-dock-top ${PCSS}-dock-bottom`);
            this._animate(from, to);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemDockElement.prototype, "mode", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemDockElement.prototype, "dock", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemDockElement.prototype, "target", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDockElement.prototype, "delay", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemDockElement.prototype, "transitionDuration", void 0);
PacemDockElement = __decorate([
    CustomElement({
        tagName: P + '-dock'
    })
], PacemDockElement);
export { PacemDockElement };
//}
